import request from "@/http";
const insertApplyData = (data) => {
  let { is_online,mid_table_remark_001,mid_table_remark_002,mid_table_remark_004,mid_table_remark_005,mid_table_remark_006,mid_table_remark_007,mid_table_remark_008,mid_table_remark_009,mid_table_remark_010,mid_table_remark_011,mid_table_remark_012,mid_table_remark_013,mid_table_remark_014,mid_table_remark_015,mid_table_remark_016,mid_table_remark_017,id_public_user_info, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_insert_or_update_middle_table",
      id_public_user_info: id_public_user_info,
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_004: mid_table_remark_004,
      mid_table_remark_005: mid_table_remark_005,
      mid_table_remark_006: mid_table_remark_006,
      mid_table_remark_007: mid_table_remark_007,
      mid_table_remark_008: mid_table_remark_008,
      mid_table_remark_009: mid_table_remark_009,
      mid_table_remark_010: mid_table_remark_010,
      mid_table_remark_011: mid_table_remark_011,
      mid_table_remark_012: mid_table_remark_012,
      mid_table_remark_013: mid_table_remark_013,
      mid_table_remark_014: mid_table_remark_014,
      mid_table_remark_015: mid_table_remark_015,
      mid_table_remark_016: mid_table_remark_016,
      mid_table_remark_017: mid_table_remark_017,
      pre_db_para_middle_table_name: "public_middle_table_80005",
      type_middle_app: 80005,
      type_inner_app: 1002,
      is_online: is_online ? is_online : 0,
    },
    loading: {
      enabled: isloading
    }
  })
}
const getApplyData = (data) => {
  let { begin_idx, limit, id_public_middle_table, pre_db_para_order_by_para, is_online, id_public_user_info, mid_table_remark_011, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_middle_table_name: "public_middle_table_80005",
      pre_db_para_order_by_para: pre_db_para_order_by_para ? pre_db_para_order_by_para : 'id_public_middle_table desc',
      id_public_middle_table: id_public_middle_table,
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_middle_app: 80005,
      type_inner_app: 1002,
      is_online_in: is_online,
      id_public_user_info: id_public_user_info,
      mid_table_remark_011: mid_table_remark_011
    },
    loading: {
      enabled: isloading
    }
  })
}
const getNeedsData = (data) => {
  let { begin_idx, limit, id_public_middle_table, pre_db_para_order_by_para, is_online, mid_table_remark_001, mid_table_remark_002, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_middle_table_name: "public_middle_table_80005",
      pre_db_para_order_by_para: pre_db_para_order_by_para ? pre_db_para_order_by_para : 'id_public_middle_table desc',
      id_public_middle_table: id_public_middle_table,
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_middle_app: 80005,
      type_inner_app: 1001,
      is_online_in: is_online,
      mid_table_remark_001_like: mid_table_remark_001,
      mid_table_remark_002_in: mid_table_remark_002
    },
    loading: {
      enabled: isloading
    }
  })
}
export default {
  insertApplyData,
  getApplyData,
  getNeedsData
}
